import { render } from "./ListeCollectionPage.vue?vue&type=template&id=46c1f7f8&ts=true"
import script from "./ListeCollectionPage.vue?vue&type=script&lang=ts"
export * from "./ListeCollectionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__